import { CONTROL_BUTTON } from "./control-style.js";

export interface RangePreset {
  label: string;
  hours: number;
}

export const RANGE_PRESETS: RangePreset[] = [
  { label: "6H", hours: 6 },
  { label: "24H", hours: 24 },
  { label: "7D", hours: 24 * 7 },
  { label: "30D", hours: 24 * 30 },
];

/**
 * Filters are standard UI, not chart marks: one row, date range first,
 * presets before a custom range. Selection is marked, not color-only.
 */
export function RangePicker({
  hours,
  onChange,
}: {
  hours: number;
  onChange: (hours: number) => void;
}) {
  return (
    // No margin here: the row that holds this owns the spacing, so this
    // component's margin box cannot pull the controls beside it out of line.
    <div style={{ display: "flex", gap: 6 }}>
      {RANGE_PRESETS.map((preset) => {
        const selected = preset.hours === hours;
        return (
          <button
            key={preset.hours}
            onClick={() => onChange(preset.hours)}
            style={{
              ...CONTROL_BUTTON,
              border: `1px solid ${selected ? "var(--text-primary)" : "var(--border)"}`,
              background: selected ? "var(--text-primary)" : "transparent",
              color: selected ? "var(--page-plane)" : "var(--text-secondary)",
            }}
          >
            {selected ? `[${preset.label}]` : ` ${preset.label} `}
          </button>
        );
      })}
    </div>
  );
}
